// Auto-extracted from uploaded files. Kept original logic.
export default function hexToRGB(hexStr) {
            var col = {};
            col.r = parseInt(hexStr.substr(1, 2), 16);
            col.g = parseInt(hexStr.substr(3, 2), 16);
            col.b = parseInt(hexStr.substr(5, 2), 16);
            return col;
        }
